import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useIsEditCartEnabled = ({ cartHasIncentive }: { cartHasIncentive?: boolean } = {}) => {
  const enableOffersEditCart = useFlag(LaunchDarklyFlag.ENABLE_OFFERS_EDIT_CART);
  return cartHasIncentive ? enableOffersEditCart : true;
};
